class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (this.form) {
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
    this.cartNotification = document.querySelector('cart-notification');
  }

  isSelectedSwatch = () => {
    let swatchesWrapper = document.querySelector('.product__info-wrapper variant-radios');
    if (!swatchesWrapper) return true;

    let swatch = document.querySelector('.product__info-wrapper variant-radios .variant-swatch-input:checked')
    let errormsg = document.querySelector(".product__info-wrapper variant-radios .product-form__input .error-msg")

    if (swatch) {
      return true
    }
    else {
      errormsg.classList.remove("d-none")
      setTimeout(() => {
        errormsg.classList.add("d-none")
      }, 4000)
      return false
    }
  };

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (!this.isSelectedSwatch()) return;
    this.cartNotification.setActiveElement(document.activeElement);
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        fetch('/?section_id=cart-notification')
          .then((response) => response.text())
          .then((data) => {
            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(data, 'text/html');
            const cart = htmlDoc.querySelector("cart-notification #cart-notification");
            const currentCartNotification = document.querySelector("cart-notification #cart-notification");

            this.cartNotification.renderCart(parsedState, {
              cartNotification: currentCartNotification,
              text: cart
            });
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
          });
      })

      .catch((e) => {
        console.error(e);
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}
customElements.define('product-form', ProductForm);